/* @jsx jsx */
import React, { useContext } from 'react'
import { jsx } from 'theme-ui'
import Text from '~/components/IntlComponents/Text'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import { merchantPriceFormatter } from '../../../utils/merchant-feed/price-formatter'
import { useEffect } from 'react'
import { ChordCartContext } from '../../Mini-Cart/CartContext'

export const FreeShippingProgress = ({ orderTotal }) => {
  const [mount, setMount] = React.useState(false)
  const translate = useTranslate()

  useEffect(() => {
    setMount(true)
  }, [setMount])

  const { amountNeededForFreeShipping } = useContext(ChordCartContext)
  const shippingIsFree = amountNeededForFreeShipping === 0
  const percent = Math.min(
    (parseFloat(orderTotal) /
      (parseFloat(orderTotal) + amountNeededForFreeShipping)) *
      100,
    100,
  )

  const message = !shippingIsFree
    ? translate('cart.shipping_banner_not_free', {
        amount: `${merchantPriceFormatter.format(amountNeededForFreeShipping)}`,
      })
    : translate('cart.shipping_banner_free')

  return (
    <div
      sx={{
        height: 'auto',
        width: '100%',
        margin: '0 auto',
        px: ['16px', '20px'],
        pt: ['0px', '20px'],
        pb: ['0px', '14px'],
      }}
    >
      {orderTotal && (
        <Text
          sx={{
            textAlign: 'center',
            color: '#FFDD00',
            whiteSpace: 'nowrap',
            pb: '6px',
          }}
          as="p"
        >
          {message}
        </Text>
      )}
      <div sx={{ position: 'relative', mt: '-6px' }}>
        <div
          sx={{
            backgroundColor: '#FFC8D033',
            clipPath: 'url(#squiggle)',
            height: '9px',
            maxHeight: '9px',
            position: 'relative',
            zIndex: 1,
            maxWidth: '365px',
            mx: 'auto',
            transform: 'translateY(100%)',
            '&:after': {
              zIndex: 2,
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              display: 'inline',
              clipPath: 'url(#squiggle)',
              width: `${percent}%`,
              height: '8px',
              backgroundColor: '#FFDD00',
              transformOrigin: 'left',
              transform: mount ? 'scaleX(1)' : 'scaleX(0)',
              transition: 'transform 0.3s ease-in, width 0.3s ease-in',
            },
          }}
        />
        <SquiglyFrame />
      </div>
    </div>
  )
}

const SquiglyFrame = () => {
  return (
    <svg
      preserveAspectRatio="none"
      width="100%"
      height="9"
      viewBox="0 0 365 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="squiggle">
        <path
          opacity="0.2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M182.686 8.99997C182.686 8.99997 182.686 8.99984 182.686 8.99962C182.687 8.9994 182.687 8.99927 182.687 8.99927C182.796 8.99926 182.902 8.99441 183.007 8.98506C187.41 8.80755 189.735 6.95085 191.62 5.44426C193.577 3.88346 194.808 2.99948 197.339 2.99948C199.872 2.99948 201.102 3.88346 203.057 5.4453L203.058 5.44603C205.041 7.0288 207.508 8.99908 212.368 8.99908C217.223 8.99908 219.69 7.02833 221.67 5.4445C223.624 3.8837 224.855 2.99972 227.384 2.99972C229.915 2.99972 231.144 3.88369 233.101 5.44554L233.104 5.44788C235.086 7.03038 237.552 8.99933 242.406 8.99933C247.265 8.99933 249.735 7.02857 251.717 5.44474C253.674 3.88289 254.905 2.99996 257.435 2.99996C259.968 2.99996 261.199 3.88394 263.155 5.44683C265.138 7.0297 267.607 8.99954 272.464 8.99954C277.323 8.99954 279.793 7.02878 281.775 5.44495C283.732 3.88311 284.963 3.00018 287.494 3.00018C290.029 3.00018 291.26 3.88415 293.215 5.44704C295.199 7.02991 297.668 8.99975 302.526 8.99975C307.384 8.99975 309.852 7.029 311.835 5.44517C313.791 3.88437 315.022 3.00039 317.553 3.00039C320.087 3.00039 321.319 3.88436 323.276 5.44621L323.28 5.44939C325.265 7.03174 327.734 9 332.592 9C337.453 9 339.922 7.03024 341.908 5.44644L341.908 5.44621C343.868 3.88436 345.099 3.00039 347.638 3.00039C350.175 3.00039 351.409 3.88437 353.369 5.44725C355.353 7.03006 357.824 8.99982 362.686 8.99997C362.686 8.99997 362.686 8.99984 362.686 8.99962C362.687 8.9994 362.687 8.99927 362.687 8.99927C363.966 8.99909 365 8.32753 365 7.50018C365 6.67164 363.964 6.00004 362.687 6.00004C360.149 6.00004 358.915 5.11606 356.956 3.55317C354.972 1.9703 352.5 0.000457764 347.639 0.000457764C342.778 0.000457764 340.307 1.97038 338.323 3.55317C336.363 5.11606 335.131 6.00004 332.592 6.00004C330.055 6.00004 328.824 5.11606 326.867 3.55317L326.863 3.54967C324.878 1.9674 322.41 0.000457764 317.553 0.000457764C312.696 0.000457764 310.227 1.97122 308.244 3.55505C306.288 5.11585 305.057 5.99982 302.526 5.99982C299.993 5.99982 298.763 5.11585 296.807 3.554L296.802 3.54925C294.817 1.96717 292.349 0.000211716 287.494 0.000211716C282.635 0.000211716 280.167 1.97017 278.185 3.554C276.229 5.11585 274.999 5.99982 272.464 5.99982C269.932 5.99982 268.701 5.11585 266.746 3.554L266.745 3.55325C264.763 1.97049 262.295 0.000211716 257.435 0.000211716C252.577 0.000211716 250.109 1.97017 248.126 3.554C246.171 5.11585 244.94 5.99982 242.406 5.99982C239.874 5.99982 238.646 5.11585 236.69 3.554L236.687 3.55164C234.705 1.96915 232.238 0.000211716 227.384 0.000211716C222.528 0.000211716 220.061 1.97097 218.08 3.5548C216.126 5.11665 214.897 5.99958 212.368 5.99958C209.834 5.99958 208.603 5.1156 206.648 3.55271C204.665 1.96984 202.196 0 197.339 0C192.483 0 190.015 1.9703 188.033 3.55295L188.032 3.55379C186.113 5.08448 184.892 5.9642 182.458 5.99757C180.073 5.94544 178.856 5.06836 176.956 3.55317C174.972 1.9703 172.5 0.000457764 167.639 0.000457764C162.778 0.000457764 160.307 1.97038 158.323 3.55317C156.363 5.11606 155.131 6.00004 152.592 6.00004C150.055 6.00004 148.824 5.11606 146.867 3.55317L146.863 3.54967C144.878 1.9674 142.41 0.000457764 137.553 0.000457764C132.696 0.000457764 130.227 1.97122 128.244 3.55505C126.288 5.11585 125.057 5.99982 122.526 5.99982C119.993 5.99982 118.763 5.11585 116.808 3.554L116.802 3.54926C114.817 1.96718 112.349 0.000211716 107.494 0.000211716C102.635 0.000211716 100.167 1.97017 98.1846 3.554C96.2294 5.11585 94.9986 5.99982 92.4645 5.99982C89.9318 5.99982 88.7011 5.11585 86.746 3.554L86.7451 3.55326C84.7627 1.97049 82.295 0.000211716 77.4354 0.000211716C72.5767 0.000211716 70.1089 1.97017 68.1264 3.554C66.1712 5.11585 64.9404 5.99982 62.4063 5.99982C59.8737 5.99982 58.6462 5.11585 56.6895 3.554L56.6866 3.55166C54.7046 1.96916 52.2385 0.000211716 47.3839 0.000211716C42.5285 0.000211716 40.0607 1.97097 38.0798 3.5548C36.1264 5.11665 34.8973 5.99958 32.368 5.99958C29.8337 5.99958 28.6029 5.1156 26.6479 3.55271C24.6654 1.96984 22.196 0 17.3389 0C12.4827 0 10.0149 1.9703 8.03265 3.55294L8.03159 3.55379C6.07481 5.11459 4.84404 5.99856 2.31315 5.99856C1.03397 5.99856 0 6.67017 0 7.49871C0 8.32725 1.03558 8.99885 2.31315 8.99885C7.17019 8.99885 9.63802 7.02809 11.6205 5.44426C13.5773 3.88346 14.808 2.99948 17.3389 2.99948C19.8716 2.99948 21.1023 3.88346 23.0574 5.4453L23.0583 5.44603C25.0407 7.0288 27.5084 8.99908 32.368 8.99908C37.223 8.99908 39.6895 7.02833 41.6704 5.4445C43.6238 3.8837 44.8546 2.99972 47.3839 2.99972C49.9149 2.99972 51.144 3.88369 53.1007 5.44554L53.1036 5.44789C55.0856 7.03038 57.5517 8.99933 62.4063 8.99933C67.265 8.99933 69.7345 7.02857 71.717 5.44474C73.6737 3.88289 74.9045 2.99996 77.4354 2.99996C79.9681 2.99996 81.1988 3.88394 83.1555 5.44683C85.138 7.0297 87.6074 8.99954 92.4645 8.99954C97.3232 8.99954 99.7927 7.02878 101.775 5.44495C103.732 3.88311 104.963 3.00018 107.494 3.00018C110.029 3.00018 111.26 3.88415 113.215 5.44704C115.199 7.02991 117.669 8.99975 122.526 8.99975C127.384 8.99975 129.852 7.029 131.835 5.44517C133.791 3.88437 135.022 3.00039 137.553 3.00039C140.087 3.00039 141.319 3.88436 143.276 5.44621L143.28 5.44934C145.265 7.0317 147.734 9 152.592 9C157.453 9 159.922 7.03021 161.908 5.44641L161.908 5.44621C163.868 3.88436 165.099 3.00039 167.638 3.00039C170.175 3.00039 171.409 3.88437 173.369 5.44725C175.262 6.9572 177.598 8.81928 182.029 8.98765C182.122 8.99504 182.217 8.99885 182.313 8.99885C182.358 8.99885 182.402 8.99868 182.446 8.99835C182.525 8.99942 182.605 8.99996 182.686 8.99997Z"
          fill="#FFC8D0"
        />
      </clipPath>
    </svg>
  )
}
